export default "__VITE_ASSET__B51wZLxz__"